import Axios from 'axios'

export default {
  updateProfile (payload) { // image,isUpdated, current_password , new_password,bio,email_address
    return Axios.post('profile/update', payload)
  }
}
